import { useGetUserByEmailQuery } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

export function useAreLabelInterestsAvailable() {
  const {
    email,
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const { data, loading } = useGetUserByEmailQuery({
    variables: {
      email,
      slug: tenantSlug,
    },
    skip: !tenantSlug, // should never happen, added for safety
    context: {
      headers: {
        slug: tenantSlug,
      },
    },
  });

  return {
    loading,
    areLabelInterestsAvailble:
      !!data?.getUserByEmail?.interests?.labelIDs?.length,
  };
}
